import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export class ReadMoreText extends Component {
  constructor (props) {
    super(props);

    this.state = {
      truncDesc: true,
      fullTextBodyHeight: 0,
      lineHeight: ''
    };

    this.toggleDesc = this.toggleDesc.bind(this);
  }

  componentDidMount () {
    this.setState({
      fullTextBodyHeight: this.textElement.clientHeight || 0,
      lineHeight: getComputedStyle(this.textElement).lineHeight
    });
  }

  toggleDesc (e) {
    e.preventDefault();
    this.setState({ truncDesc: !this.state.truncDesc });
  }

  render () {
    const { text, unescapeText, textClass, linesToDisplay, linkStyling = '' } = this.props;
    const { truncDesc, fullTextBodyHeight, lineHeight } = this.state;

    const clientTextBodyHeight = lineHeight.slice(0, -2) * linesToDisplay;
    const isWrapped = fullTextBodyHeight > clientTextBodyHeight;
    const hideBtnStyle = { marginTop: '8px' };
    const wrapperStyling = (truncDesc && isWrapped) ? { WebkitLineClamp: linesToDisplay } : { whiteSpace: 'pre-wrap' };
    const unescapedText = () => (<span dangerouslySetInnerHTML={ { __html: text } } />);
    const textToDisplay = unescapeText ? unescapedText() : text;
    const btnClassNames = `toggle-txt-btn btn-link ${linkStyling}`;
    const readMoreBtn = (
      <button className={btnClassNames} onClick={this.toggleDesc} style={ !truncDesc ? hideBtnStyle : {} }>
        { truncDesc
          ? <FormattedMessage
            id="listing.production_faq.read_more"
            defaultMessage="Read more"
          />
          : <FormattedMessage
            id="listing.production_faq.hide"
            defaultMessage="Hide"
          />}
      </button>
    );

    return (
      <div>
        <div className="read-more-text-wrapper">
          <p className={ textClass } ref={ (textElement) => { this.textElement = textElement }} style={ wrapperStyling }>
            {textToDisplay}
          </p>

          { truncDesc ? null : this.props.children }
        </div>
        {isWrapped && readMoreBtn}
      </div>
    );
  }
}

ReadMoreText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linesToDisplay: PropTypes.number,
  unescapeText: PropTypes.bool,
  textClass: PropTypes.string,
  linkStyling: PropTypes.string
};
